// extracted by mini-css-extract-plugin
module.exports = {"Player":"Player_Player__IgLvH","Player--cover":"Player_Player--cover__Q4OmM"};